export default "__VITE_ASSET__1da15819__"